export default __webpack_public_path__ + "static/media/icon-192x192.e1998f5f.png";